(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
document.addEventListener('change',event=>{const select=event.target.closest('[data-b30-blog-category]');if(!select||!select.value)return;const url=new URL(select.value,location.href),here=new URL(location.href);['preview_theme_id','preview_key','_fd','_ss'].forEach(k=>{if(here.searchParams.has(k))url.searchParams.set(k,here.searchParams.get(k));});location.assign(url.href);});

  } catch(e) { console.error(e); }
})();
})();
